import { ChangeDetectorRef, Component, ViewContainerRef, ViewEncapsulation } from '@angular/core';

import { PetlService } from '../../../services/petl.service';
import { PetlBaseComponent } from '../petl-base.component';

@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-petl-about-ng',
    styleUrls: ['../../sharedStyles/base.scss', '../petl-base.scss'],
    templateUrl: './about.component.html'
})

export class PetlAboutComponent extends PetlBaseComponent {

    constructor(_vcr: ViewContainerRef, protected readonly petlService: PetlService, protected readonly cdr: ChangeDetectorRef) {
        super(_vcr, petlService, cdr);
    }

    toggleAbout() {
        this.toggleView('about');
    }
}
